/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadScreenerLeadTagsInnerScreenerTag
 */
export interface LeadScreenerLeadTagsInnerScreenerTag {
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadTagsInnerScreenerTag
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadTagsInnerScreenerTag
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof LeadScreenerLeadTagsInnerScreenerTag
     */
    type?: number;
}

/**
 * Check if a given object implements the LeadScreenerLeadTagsInnerScreenerTag interface.
 */
export function instanceOfLeadScreenerLeadTagsInnerScreenerTag(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadScreenerLeadTagsInnerScreenerTagFromJSON(json: any): LeadScreenerLeadTagsInnerScreenerTag {
    return LeadScreenerLeadTagsInnerScreenerTagFromJSONTyped(json, false);
}

export function LeadScreenerLeadTagsInnerScreenerTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadTagsInnerScreenerTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function LeadScreenerLeadTagsInnerScreenerTagToJSON(value?: LeadScreenerLeadTagsInnerScreenerTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
    };
}

